/***************************************************************************************
* FileName      : MyLikes.js
* Description   : 소곤핏 마이페이지 > 관심목록
* Company       : (주)엘리그
* Author        : 박권희
* Created Date  : 2024.05.09
* Modifide Date :
*               : 
* Reference     : 
***************************************************************************************/
import React, { useState , useEffect } from 'react';
import MobileHeader from "./Component/MobileHeader";
import Gnb from '../../Gnb';

import { useInfiniteQuery } from 'react-query';

import Postitem from './Post/Postitem';

import InfiniteScroll from 'react-infinite-scroll-component';
import { LoadingSpinner } from '../admin/Component/LoadingSpinner';

import { fetchLikePost } from '../../api/services/mypageApi';
import Likeitem from './Mypage/MyLikes/Likeitem';
function MyLikes()
{
    const [page, setPage] = useState(0);
    const [tag, setTag] = useState('all');

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetching,
        isFetchingNextPage,
        isLoading,
      } = useInfiniteQuery(  ['likePost', page], ({ pageParam = 1 }) => fetchLikePost(pageParam), {
        getNextPageParam: (lastPage, allPages) => {
          return lastPage.nextPage; 
        },
    });


    return (
        
        <>
        <MobileHeader back={true} title={"관심 목록"}/>
         <div className="mypage">
            <section className='mypage-menu my-5'>
                <div className="inner">
          
                <div className="post-wrap">
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                <>
                {data.pages.length === 0 || data.pages.reduce((total, page) => total + page.data.length, 0) === 0 ? (
                    <div className='text-center mt-3'>
                        좋아요를 눌러 보세요
                    </div>
                ) : (
                    <InfiniteScroll 
                        style={{ display: 'flex', flexWrap: 'wrap', gap : '10px' }}
                        dataLength={data.pages.reduce((total, page) => total + page.data.length, 0)}
                        next={() => fetchNextPage()}
                        hasMore={hasNextPage}
                        loader={<div>Loading...</div>}
                        endMessage={<div></div>}
                    >
                    {data?.pages.map((page, pageIndex) => (
                        <React.Fragment key={pageIndex}>
                            {page.data.map(item => (
                                <Likeitem item={item} key={item.id} />
                            ))}
                        </React.Fragment>
                    ))}
                    </InfiniteScroll>
                )}
                </>
                )}
                
                </div>
                </div>
            </section>

            <Gnb/>
        </div>
        </>
    )
}

export default MyLikes;